export const checkFileName = (name1: string, name2: string): boolean => {
  return (
    name1.split('.').length === 2 &&
    name1.split('.').length === name2.split('.').length &&
    name1.split('.')[0] === name2.split('.')[0] &&
    name1.split('.')[name1.split('.').length - 1].toLowerCase() === name2.split('.')[name2.split('.').length - 1].toLowerCase()
  );
};
